export default __webpack_public_path__ + "static/media/what-we-provide-processes-icon.421402a2.svg";